export default {
  "global.loading": "Betöltés",
  "global.something_went_wrong": "Hiba történt",
  "global.assessor": "Kiértékelő",
  "global.supervisor": "Felügyelő",
  "pageTitle.login": "Bejelentkezés",
  "pageTitle.leaders": "Líderek",
  "pageTitle.dashboard": "Irányítópult",
  "pageTitle.tasks_registration": "Résztvevő regisztráció",
  "pageTitle.tasks_activity_approvals": "Tevékenység jóváhagyása",
  "pageTitle.tasks_activity_signoffs": "Szakasz jóváhagyása",
  "pageTitle.tasks_aj": "Kaland",
  "pageTitle.tasks_award_signoff": "Award jóváhagyása",
  "pageTitle.tasks_unassigned_participants": "Nem beosztott résztvevők",
  "pageTitle.profile": "Profil",
  "pageTitle.my_participants": "Résztvevőim",
  "pageTitle.all_participants": "Minden résztvevő",
  "pageTitle.new_participant": "Új résztvevő",
  "pageTitle.my_aj_events": "Kalanddal kapcsolatos eseményeim",
  "pageTitle.all_aj_events": "Összes kalanddal kapcsolatos esemény",
  "pageTitle.new_aj_event": "Új kalanddal kapcsolatos esemény",
  "pageTitle.my_organization": "A szervezetem",
  "pageTitle.my_organization_contacts": "A szervezetem - elérhetőségek",
  "pageTitle.my_organization_templates": "A szervezetem - sablonok",
  "pageTitle.aj_template_new": "Új kaland sablon",
  "pageTitle.aj_template_detail": "Kaland",
  "pageTitle.reports": "Jelentések",
  "pageTitle.settings": "Beállítások",
  "pageTitle.award_units": "Programközpontok",
  "pageTitle.national_offices": "Országos iroda",
  "pageTitle.nao_detail": "Országos iroda - adatok",
  "pageTitle.nao_registration": "Országos iroda - regisztráció",
  "pageTitle.nao_payment": "Országos iroda - fizetés",
  "pageTitle.nao_awards": "Országos iroda - Awardok",
  "pageTitle.nao_award_units": "Országos iroda - programközpontok",
  "pageTitle.nao_award_leaders": "Országos iroda - Award Líderek",
  "pageTitle.nao_participants": "Országos iroda - résztvevők",
  "pageTitle.mro_logs": "Regionális irodám - bejegyzések",
  "pageTitle.mro_related_contacts": "Regionális irodám - elérhetőségek",
  "pageTitle.mro_related_detail": "Regionális irodám - adatok",
  "pageTitle.assessor_report": "Kiértékelői jelentés",
  "pageTitle.assessor_report_reject": "Kiértékelői jelentés felülvizsgálata",
  "pageTitle.contacts": "Elérhetőségek",
  "pageTitle.new_contact": "Új elérhetőség",
  "pageTitle.mro": "Regionális irodám",
  "pageTitle.mro_detail": "Regionális irodám - adatok",
  "pageTitle.registrations": "Regisztrációk",
  "pageTitle.residetial_project_assessor_report": "Tartózkodási Projekt - kiértékelői jelentés",
  "header.appMotto": "DUKE",
  "sidebar.dashboard": "Irányítópult",
  "sidebar.todolist": "Tennivalók",
  "sidebar.registrations": "Regisztrációk",
  "sidebar.payments": "Kifizetések",
  "sidebar.participants": "Résztvevők",
  "sidebar.leaders": "Líderek",
  "sidebar.award_units": "Programközpontok",
  "sidebar.adventure_journey": "Kaland",
  "sidebar.my_organization": "A szervezetem",
  "sidebar.awards": "Awardok",
  "sidebar.variables": "Változók",
  "sidebar.reports": "Jelentések",
  "sidebar.mynao": "Az országos programoperátorom",
  "sidebar.settings": "Beállítások",
  "sidebar.my_region_office": "A regionális irodám",
  "sidebar.naos": "Országos programoperátorok",
  "dashboard.while_you_were_gone": "Amíg távol voltál",
  "dashboard.your_todo_list": "A tennivalóid",
  "dashboard.participant_by_level": "Résztvevők - szint szerint",
  "dashboard.leader_state": "Líderek - országonként",
  "dashboard.award_approved_by": "Jóváhagyott Awardok - szint szerint 2016-ban",
  "dashboard.charts": "Grafikonok",
  "dashboard.type_of_awards": "Programközpont típus",
  "route.dashboard": "Irányítópult",
  "route.leaders": "Líderek",
  "route.profile": "Profil",
  "route.registrations": "Regisztrációk",
  "route.history_log": "Előzménynapló",
  "route.award": "Award",
  "route.tasks": "Feladatok",
  "route.award_units": "Programközpontok",
  "route.registration_participants": "Regisztráció, résztvevők",
  "route.bronze_level": "Bronz fokozat",
  "route.silver_level": "Ezüst fokozat",
  "route.gold_level": "Arany fokozat",
  "route.participants": "Résztvevők",
  "route.detail": "Adat",
  "route.levels": "Szintek",
  "route.adventurous_journeys": "Kalandok",
  "route.my_events": "Eseményeim",
  "route.section_signoff": "Szakasz jóváhagyása",
  "route.event_participants": "Esemény résztvevők",
  "route.my_participants": "Résztvevőim",
  "route.my_organization": "Szervezetem",
  "route.national_offices": "Országos irodák",
  "route.my_national_office": "Országos irodám",
  "route.activity_approval": "Tevékenység jóváhagyása",
  "route.templates": "Sablonok",
  "label.save": "Mentés",
  "label.note_from_participant": "Megjegyzés résztvevőtől",
  "label.goal": "Célkitűzés",
  "label.search_by_email_first_or_last": "Keresés e-mail, keresztnév vagy családnév szerint",
  "label.no_roles": "Nincsenek szerepek",
  "label.no_note": "Nincs megjegyzés",
  "label.no_data_to_show": "Nincs megjeleníthető adat",
  "label.no_data": "NINCS ELÉRHETŐ ADAT.\nVagy az Award ezen része nincs beállítva, vagy nincs hozzáférése ehhez az információhoz (ez abban az esetben következhet be, amikor egy résztvevő  egy másik programközponttól iratkozott át)",
  "label.other_activity": "Egyéb tevékenység",
  "label.observations": "Észrevételek",
  "label.no": "Nem",
  "label.yes": "Igen",
  "label.region": "Régió",
  "label.role": "Szerep",
  "label.start_date": "Kezdési dátum",
  "label.end_date": "Befejezési dátum",
  "label.project_location_type": "Projekt helyszínének típusa",
  "label.location_detail": "Helyszín részletek",
  "label.activation_date": "Aktiválás dátuma",
  "label.email_confirmation": "E-mail visszaigazolása",
  "label.language_settings": "Nyelvi beállítások",
  "label.system_rights": "Rendszerjogosultságok",
  "label.nominated_and_identified_persons": "Kijelölt és azonosított személyek, akik minden adatot láthatnak, de nem szerkeszthetik azokat",
  "label.parent_approval": "Szülői jóváhagyás",
  "label.payment_state": "Fizetés állapota",
  "label.title": "Cím",
  "label.name": "Név",
  "label.duration": "Időtartam",
  "label.description": "Leírás",
  "label.first_name": "Keresztnév",
  "label.last_name": "Családnév",
  "label.middle_name": "Középső név",
  "label.participant_status": "Résztvevő státusz",
  "label.assessor_report": "Kiértékelői jelentés",
  "label.supervisor_report": "Felügyelői jelentés",
  "label.email": "E-mail",
  "label.birthdate": "Születési dátum",
  "label.age": "Életkor",
  "label.type": "Típus",
  "label.organization": "Szervezet",
  "label.organization_name": "Szervezet neve",
  "label.phone_number": "Telefonszám",
  "label.role_in_organisation": "Szervezetben betöltött szerep",
  "label.registration_date": "Regisztráció dátuma",
  "label.last_activity": "Utolsó tevékenység",
  "label.level": "Szint",
  "label.note": "Megjegyzés",
  "label.journey_category": "Utazás típusa",
  "label.journey_type": "Utazás típusa",
  "label.journey_activity": "Utazás tevékenység",
  "label.mode_of_transport": "Utazási mód",
  "label.suitable_for_level": "A szintnek megfelelő",
  "label.search": "Keresés",
  "label.payment_confirmed": "Fizetés igazolva",
  "label.form_of_payment": "Fizetési mód",
  "label.date_of_payment": "Fizetési dátum",
  "label.date": "Dátum",
  "label.phone": "Telefon",
  "label.transation_id": "Tranzakció azonosítója",
  "label.phone_type": "Telefon típusa",
  "label.street": "Utca",
  "label.state_province": "Állam/Tartomány/Régió",
  "label.city": "Város",
  "label.post_code": "Postai irányítószám",
  "label.country": "Ország / Terület",
  "label.date_of_delivery": "Átvétel dátuma",
  "label.delivery_confirmed": "Átadás igazolva",
  "label.parent_agreement": "Nyomtatható szülői beleegyezés űrlap",
  "label.parent_relationship": "Szülő kapcsolata",
  "label.parent_first_name": "Szülő/gyám keresztneve",
  "label.parent_last_name": "Szülő/gyám családneve",
  "label.parent_email": "Szülő/Gyám e-mail címe",
  "label.parent_phone": "Szülő/Gyám telefonszáma",
  "label.employement_status": "Foglalkoztatási státusz",
  "label.gender": "Nem",
  "label.nationality": "Nemzetiség",
  "label.previous_completed_award_place": "Hol",
  "label.previous_completed_award_level": "Előző szint (nem ORB)",
  "label.label.participant_status": "Résztvevő státusz",
  "label.activity": "Tevékenység",
  "label.activity_type": "Tevékenység típusa",
  "label.addressLine1": "Cím első sor",
  "label.addressLine2": "Cím második sor",
  "label.optional": "(opcionális)",
  "label.aim": "Célkitűzés",
  "label.major": "Fő",
  "label.location": "Helyszín",
  "label.other_location_information": "Egyéb helyszín információk",
  "label.find_address": "Cím megtalálása",
  "label.created": "Létrehozva",
  "label.created_by": "Létrehozó",
  "label.active_participants": "Aktív résztvevők",
  "label.total_participants": "Összes résztvevő",
  "label.active_leaders": "Aktív Líderek",
  "label.website": "Honlap",
  "label.dofe": "International Award",
  "label.facebook": "Facebook",
  "label.twitter": "Twitter",
  "label.youtube": "YouTube",
  "label.relationship_to_participant": "Kapcsolat a résztvevővel",
  "label.training_name": "Képzés neve",
  "label.your_report_has_been_successfully_sent": "A jelentés elküldése sikeres.",
  "label.my_experience": "Tapasztalatom",
  "label.my_qualification": "Képzettségem",
  "label.i_certify_that_as_the_assessor": "A kiértékelő{role} szerepében igazolom, hogy a résztvevő teljesítette az elvárásokat.",
  "button.set_participants": "Résztvevők beállítása",
  "button.manage_participants": "Résztvevők rendezése",
  "button.filter": "Szűrés",
  "button.remove": "Eltávolítás",
  "button.add_role": "Szerep hozzáadása",
  "button.create": "Létrehozás",
  "button.account_settings": "Fiók beállítások",
  "button.contact_settings": "Elérhetőség beállítások",
  "button.cancel": "Mégsem",
  "button.clear": "Törlés",
  "button.change": "Módosítás",
  "button.approve": "Jóváhagyás",
  "button.return": "Felülvizsgálat",
  "button.revise": "Felülvizsgálat",
  "button.reject": "Felülvizsgálat",
  "button.edit": "Szerkesztés",
  "button.save": "Mentés",
  "button.close": "Bezárás",
  "button.dismiss": "Elutasítás",
  "button.confirm": "Igazolás",
  "button.view": "Megtekintés",
  "button.delete": "Törlés",
  "button.assign": "Kijelölés",
  "button.assign_leader": "Líder kijelölése",
  "button.show_more": "Még több megjelenítése",
  "button.add_log": "Napló hozzáadása",
  "button.add": "Hozzáadás",
  "button.send": "Küldés",
  "button.delete_registration": "Regisztráció törlése",
  "button.select_template": "Sablon kiválasztása",
  "button.same_as_billing": "Ugyanaz, mint a számlázás",
  "button.leave_anyway": "Kilépés mindenképp",
  "button.stay": "Maradok az oldalon",
  "button.new_contact": "Új elérhetőség",
  "notifications.saved": "Mentve",
  "notifications.payment_info_updated": "Fizetési információk frissítve",
  "notifications.participant_has_been_assigned": "Résztvevő beosztva",
  "notifications.activity_has_been_updated": "Tevékenység frissítve",
  "notifications.award_has_been_updated": "Award frissítve",
  "notifications.activity_has_been_approved": "Tevékenység jóváhagyva",
  "notifications.activity_has_been_returned": "Tevékenység felülvizsgálva",
  "notifications.section_has_been_signed_off": "Szakasz aláírva",
  "notifications.section_has_been_returned": "Szakasz felülvizsgálva",
  "notifications.new_log_has_been_added": "Új napló hozzáadva",
  "notifications.log_has_been_modified": "Napló módosítva",
  "notifications.aj_event_has_been_created": "Kaland-esemény létrehozva",
  "notifications.adventurous_journey_has_been_approved": "Kaland jóváhagyva",
  "notifications.adventurous_journey_has_been_returned": "Kaland felülvizsgálva",
  "notifications.event_has_been_approved": "Esemény jóváhagyva",
  "notifications.event_has_been_rejected": "Esemény felülvizsgálva",
  "notifications.participants_have_been_added": "Résztvevők hozzáadva",
  "notifications.participants_have_been_saved": "Résztvevők mentve",
  "notifications.new_template_has_been_created": "Új sablon létrehozva",
  "notifications.new_template_has_been_updated": "Új sablon frissítve",
  "notifications.award_has_been_returned": "Award felülvizsgálva",
  "notifications.award_has_been_signed_off": "Award aláírva",
  "notifications.award_leader_has_been_approved": "Líder jóváhagyva",
  "notifications.award_leader_has_been_returned": "Líder felülvizsgálva",
  "notifications.award_leader_has_been_moved": "Líder átirányítva",
  "notifications.award_leader_has_been_assigned": "Líder kijelölve",
  "notifications.award_unit_has_been_approved": "Programközpont engedélyezve",
  "notifications.award_unit_has_been_returned": "Programközpont felülvizsgálva",
  "notifications.organization_has_been_updated": "Szervezet frissítve",
  "notifications.participant_has_been_updated": "Résztvevő frissítve",
  "notifications.participant_has_been_created": "Résztvevő létrehozva",
  "notifications.participant_has_been_deleted": "Résztvevő törölve",
  "notifications.personal_details_have_been_updated": "Személyes adatok frissítve",
  "notifications.rp_has_been_updated": "Aranyfokozatú tartózkodási projekt frissítve",
  "notifications.rp_has_been_approved": "Aranyfokozatú tartózkodási projekt jóváhagyva",
  "notifications.rp_has_been_returned": "Aranyfokozatú tartózkodási projekt felülvizsgálva",
  "notifications.rp_has_been_signed_off": "Aranyfokozatú tartózkodási projekt aláírva",
  "notifications.participant_has_been_approved": "Résztvevő jóváhagyva",
  "notifications.you_have_been_logged_in": "Bejelentkezése sikeres volt",
  "notifications.something_went_wrong": "Hiba történt",
  "notifications.you_have_been_logged_out": "Kijelentkezett",
  "notifications.logging_out": "Kijelentkezés…",
  "notifications.training_has_been_added": "Képzés hozzáadva",
  "notifications.training_has_been_updated": "Képzés frissítve",
  "notifications.training_has_been_removed": "Képzés visszavonva",
  "notifications.award_leader_has_been_updated": "Líder frissítve",
  "notifications.parental_consent_has_been_sent": "Szülői beleegyezés elküldve",
  "notifications.authorization_code_is_no_longer_valid": "Engedélyezési kód már nem érvényes",
  "notifications.invitation_has_been_sent": "Meghívó elküldve",
  "notifications.password_change_request_has_been_sent": "Kérés jelszó megváltoztatására elküldve",
  "notifications.contact_has_been_removed": "Elérhetőség visszavonva",
  "notifications.contact_has_been_created": "Elérhetőség létrehozva",
  "notifications.contact_has_been_updated": "Elérhetőség frissítve",
  "notifications.new_role_has_been_added": "Új szerep hozzáadva",
  "notifications.role_has_been_removed": "Szerep visszavonva",
  "notifications.auth_code_is_no_longer_valid": "Engedélyezési kód nem érvényes",
  "modal.close": "Bezárás",
  "modal.select": "Kiválasztás",
  "tabs.registration": "Regisztráció",
  "tabs.user_management": "Felhasználók kezelése",
  "tabs.localization_files": "Lokalizációs fájlok",
  "tabs.customization": "Személyre szabás",
  "tabs.logs": "Naplók",
  "tabs.registrations": "Regisztrációk",
  "tabs.my_national_office": "Országos irodám",
  "tabs.leaders": "Líderek",
  "tabs.activity_approval": "Tevékenység jóváhagyása",
  "tabs.section_approval": "Szakasz jóváhagyása",
  "tabs.activity_signoff": "Szakasz jóváhagyása",
  "tabs.adventurous_journey": "Kaland",
  "tabs.award_signoff": "Award jóváhagyása",
  "tabs.award": "Award",
  "tabs.unassigned_participants": "Nem beosztott résztvevők",
  "tabs.my_participants": "Résztvevőim",
  "tabs.all_participants": "Minden résztvevő",
  "tabs.detail": "Részlet",
  "tabs.levels": "Szintek",
  "tabs.bronze_level": "Bronz fokozat",
  "tabs.silver_level": "Ezüst fokozat",
  "tabs.gold_level": "Arany fokozat",
  "tabs.awards": "Awardok",
  "tabs.award_units": "Programközpontok",
  "tabs.participants": "Résztvevők",
  "tabs.award_leaders": "Líderek",
  "tabs.history_log": "Előzménynapló",
  "tabs.my_events": "Eseményeim",
  "tabs.all_events": "Összes esemény",
  "tabs.new_template": "Új sablon",
  "tabs.new_aj_event": "Új kaland-esemény",
  "tabs.organization_detail": "Szervezeti adatok",
  "tabs.contacts": "Elérhetőségek",
  "tabs.aj_templates": "Kaland sablonok",
  "tabs.office_details": "Iroda adatok",
  "tabs.related_contacts": "Kapcsolódó elérhetőségek",
  "tabs.payment": "Fizetés",
  "table.actions": "Teendők",
  "table.region": "Régió",
  "table.type": "Típus",
  "table.nao": "Országos programoperátor",
  "table.first_activity_started": "Első tevékenység elkezdve",
  "table.major": "Fő",
  "table.completed": "Teljesítve",
  "table.created": "Létrehozva",
  "table.started_at": "Kezdés dátuma",
  "table.hours_completed_required": "Teljesítve / kötelező",
  "table.system_rights": "Rendszerjogosultságok",
  "table.no_filtered_results": "Szűrés nem járt eredménnyel",
  "table.no_results": "Nincs találat",
  "table.per_page": "Oldalanként",
  "table.name": "Név",
  "table.registration": "Regisztráció",
  "table.payments": "Kifizetések",
  "table.awards": "Awardok",
  "table.aus": "Programközpontok",
  "table.leaders": "Líderek",
  "table.participants": "Résztvevők",
  "table.state": "Állam",
  "table.id": "Azonosító",
  "table.first_name": "Keresztnév",
  "table.last_name": "Családnév",
  "table.registration_date": "Regisztráció dátuma",
  "table.progress": "Eredmények",
  "table.last_activity": "Utolsó tevékenység",
  "table.email_confirmation": "E-mail visszaigazolása",
  "table.email": "E-mail",
  "table.phone": "Telefon",
  "table.main_award_leader": "Koordinátor",
  "table.suitable_for_award_level": "A szintnek megfelelő",
  "table.location": "Helyszín",
  "table.preparation": "Felkészülés",
  "table.practice": "Gyakorló",
  "table.qualifying": "Minősítő",
  "table.report": "Jelentés",
  "table.parent_approval": "Szülői engedély",
  "table.payment": "Fizetés",
  "table.level": "Szint",
  "table.levels": "Szintek",
  "table.activity": "Tevékenység",
  "table.activity_type": "Tevékenység típusa",
  "table.goal": "Célkitűzés",
  "table.finished": "Befejezve",
  "table.status": "Státusz",
  "table.logs": "Naplók",
  "table.assessor_approve": "Kiértékelő jóváhagyás",
  "table.assessor_approval": "Kiértékelő engedélyezés",
  "table.note_for_al": "Megjegyzés a Lídernek",
  "table.action": "Akció",
  "table.aj_detail": "Kaland adata",
  "table.evidence": "Bizonyíték",
  "table.journey_category": "Utazás típusa",
  "table.journey_activity": "Utazási tevékenység",
  "table.journey_type": "Utazás típusa",
  "table.award_unit": "Programközpont",
  "table.delete": "Törlés",
  "table.assign": "Kijelölés",
  "table.aim": "Célkitűzés",
  "table.approve": "Jóváhagyás",
  "table.edit": "Áttekintés",
  "table.start_date": "Kezdés dátuma",
  "table.end_date": "Befejezés dátuma",
  "table.created_by": "Létrehozó",
  "table.previous_level": "Előző szint",
  "table.current_level": "Jelenlegi szint",
  "table.award_duration": "Award időtartama",
  "table.already_running": "Már folyamatban",
  "table.licence_holder": "Licenc birtokosa",
  "table.role": "Szerep",
  "tasks.approve_task": "Feladat jóváhagyása",
  "tasks.approve_item": "Tétel jóváhagyása",
  "tasks.return_task": "Feladat felülvizsgálata",
  "tasks.revise_task": "Feladat felülvizsgálata",
  "tasks.revise_item": "Tétel felülvizsgálata",
  "tasks.reject_registration": "Regisztráció felülvizsgálata",
  "tasks.approve_award_registration": "Award regisztráció jóváhagyása",
  "tasks.return_registration": "Regisztráció felülvizsgálata",
  "tasks.approve_event": "Esemény jóváhagyása",
  "tasks.approve_award": "Award jóváhagyása",
  "tasks.return_award": "Awardfelülvizsgálata",
  "tasks.reject_event": "Esemény felülvizsgálata",
  "tasks.would_you_like_to_delete": "Törölni akarja a résztvevőt?",
  "tasks.evidence": "Bizonyíték",
  "tasks.observations": "Megfigyelések",
  "tasks.no_evidence": "Nincs csatolva bizonyíték",
  "award.physical_recreation": "Testmozgás",
  "award.skills": "Készségek",
  "award.service": "Önkéntes szolgálat",
  "award.rp": "Tartózkodási projekt",
  "award.aj": "Kaland",
  "award.ajs": "Kaland",
  "award.no_data": "Nem jelennek meg ennek a Awardnak az adatai.",
  "award.no_data_to_show": "Nincs megjeleníthető adat",
  "aj.preparation": "Felkészülés",
  "aj.practice": "Gyakorló",
  "aj.qualifying": "Minősítő",
  "aj.aj_events": "Kaland-események",
  "aj.preparation_and_training": "Felkészülés és gyakorlás",
  "aj.practice_journey": "Gyakorló utazás",
  "aj.qualifying_journey": "Minősítő utazás",
  "aj.cannot_modify_award": "A Award fokozat nem módosítható, ha résztvevők vannak bejelölve a kalandhoz",
  "ajTemplates.fill_from_template": "Kitöltés sablonból",
  "participant.would_you_like_to_delete": "Törlöd  a fiókot?",
  "participant.account_detail": "Fiók beállítások",
  "participant.would_you_like_to_remove": "Törölöd a fiókot?",
  "participant.leader_must_be_selected": "Ki kell választanod a vezetőt",
  "participant.level_start_date": "{value} Kezdés dátuma",
  "participant.send_email_invitation_again": "Újraküldöd a meghívó e-mailt?",
  "participant.recover_password": "Jelszó visszaszerzése",
  "participant.history_log": "Előzménynapló",
  "participant.delete_account": "Elérhetőség törlése",
  "participant.account_settings": "Fiók beállítások",
  "participant.send_email_invitation_again_question": "Újraküldöd a meghívó e-mailt?",
  "participant.send_password_recovery_email": "Elküldöd a jelszó visszaszerzése e-mailt?",
  "moduleTitle.overview": "Áttekintés",
  "moduleTitle.leader": "Vezető",
  "moduleTitle.note_for_al": "Megjegyzés Award Lídernek",
  "moduleTitle.assessor_report": "{role} jelentés",
  "moduleTitle.payment": "Fizetés",
  "moduleTitle.assessed_by_award_leader": "Award Líder kiértékelte",
  "moduleTitle.billing_address": "Számlázási cím",
  "moduleTitle.add_role": "Szerep hozzáadása",
  "moduleTitle.remove_role": "Visszavonja a szerepet?",
  "moduleTitle.shipping_address": "Szállítási cím",
  "moduleTitle.address": "Cím",
  "moduleTitle.address_line_1": "Cím első sor",
  "moduleTitle.address_line_2": "Cím második sor",
  "moduleTitle.role": "Szerep",
  "moduleTitle.parent_consent_form": "Szülő/gyám beleegyezési űrlap",
  "moduleTitle.your_personal_information": "Személyes adataid",
  "moduleTitle.contact_settings": "Elérhetőség beállítások",
  "moduleTitle.parent_consent": "Szülő/gyám beleegyezés",
  "moduleTitle.other_info": "Egyéb információk",
  "moduleTitle.nao_specific_info": "Országos programoperátor specifikus információk",
  "moduleTitle.activity_detail": "Tevékenység adatok",
  "moduleTitle.logs": "Naplók",
  "moduleTitle.assessor": "Kiértékelő",
  "moduleTitle.supervisor": "Felügyelő",
  "moduleTitle.dates": "Dátumok",
  "moduleTitle.main_award_leader": "Koordinátor",
  "moduleTitle.personal_details": "Személyes adatok",
  "moduleTitle.authorising_contact": "Licenc tulajdonosa/Engedélyező elérhetősége",
  "moduleTitle.contact_info": "Elérhetőségi adatok",
  "moduleTitle.new_contact": "Új elérhetőség",
  "moduleTitle.activity_leader": "Tevékenység vezető",
  "moduleTitle.profile_questions": "Profilkérdések",
  "moduleTitle.would_you_like_to_remove_participant": "Szeretnéd törölni ezt a résztvevői regisztrációt?",
  "moduleTitle.would_you_like_to_remove_leader_training": "Szeretnéd törölni a Award Líder képzését?",
  "moduleTitle.your_home_address": "Otthoni címed",
  "moduleTitle.requirements_and_conditions": "Követelmények és feltételek",
  "moduleTitle.your_parental_consent": "Szülői beleegyezésed",
  "roles.leader": "Vezető",
  "roles.award_verifier": "Award ellenőr",
  "roles.coordinator": "Koordinátor",
  "roles.aj_assessor": "Kaland kiértékelő",
  "roles.aj_supervisor": "Kaland felügyelő",
  "roles.instructor": "Oktató",
  "roles.nao_staff": "Országos programoperátor személyzet",
  "roles.assessor": "Kiértékelő",
  "roles.super_user": "Szuper-felhasználó",
  "roles.user": "Statisztikai",
  "roles.viewer": "Megtekintő",
  "roles.authorizing_contact": "Engedélyező elérhetőség",
  "logs.no_logs": "Nincsenek naplók",
  "logs.hour": "óra",
  "logs.hours": "óra",
  "logs.minute": "perc",
  "logs.minutes": "perc",
  "logs.edit_log": "Napló szerkesztése",
  "logs.add_log": "Napló hozzáadása",
  "states.setup": "Beállítás",
  "states.approval": "Jóváhagyás",
  "states.in_progress": "Folyamatban",
  "states.assessor_approval": "Kiértékelő jóváhagyása",
  "states.awaiting_sign_off": "Award Líder jóváhagyása",
  "states.awaiting_office_sign_off": "Programközpont jóváhagyása",
  "states.office_sign_off": "Programközpont jóváhagyása",
  "states.ceremony_certificate": "Ceremónia",
  "states.ceremony": "Ceremónia",
  "states.completed": "Teljesítve",
  "states.change_to_state": "Változtatás erre: <strong>{state}</strong>",
  "states.award_leader_approval": "Award Líder jóváhagyása",
  "states.award_leader_signoff": "Award Líder jóváhagyása",
  "states.organization_approval": "Programközpont jóváhagyása",
  "states.award_level_complete": "Award fokozat teljes",
  "states.registration_assessment": "Regisztráció kiértékelése",
  "states.registration_approval": "Regisztráció jóváhagyása",
  "states.registration_not_approved": "Regisztráció nincs jóváhagyva",
  "map.appr_location": "Hozzávetőleges cím:",
  "parentalConsent.this_form_must_be_completed": "Ezt a nyomtatványt egy szülőnek/gyámnak <strong>kell</strong> kitöltenie <strong> 18 év alatti résztvevők esetében vagy olyan résztvevők esetében, akik az országuk szerinti legális korhatárt még nem töltötték be</strong>.",
  "parentalConsent.form_has_been_sent": "Szülői beleegyezés elküldve.",
  "parentalConsent.checkbox_copy": "Igazolom, hogy {firstName} {lastName} szülője/gyámja vagyok. Beleegyezem abba, hogy részt vegyen a programban, {organisationName} szervezetben, egy képzett Award Líder felügyelete alatt. A programban való részvétel fentiekben leírt és a programoperátor honlapján közzétett követelményeit és feltételeit elolvastam, megértettem, és azokkal egyetértek.",
  "parentalConsent.as_the_parent": "Szülőként/gyámként beleegyezem abba, hogy a program során készült fényképeket, valamint az annak végén írt személyes gondolatokat a Nemzetközi Award Alapítvány felhasználja a program népszerűsítésére.",
  "parentalConsent.i_understand_that_the_participant": "1. Megértettem, hogy a résztvevő nem kapcsolódhat be a programba mindaddig, amíg a jelen nyomtatványt ki nem töltötte (ideértve a szülői/gyám beleegyező nyilatkozatát) és visszaküldte a megfelelő programoperátornak az érvényes regisztrációs díjjal együtt, és azt a programközpont el nem fogadta.",
  "parentalConsent.i_consent_to_the_award_unit": "2. Beleegyezem a programközpont és minden más egyén részvételébe, ideértve önkénteseket*, akik segítenek a program lebonyolításában, felfogadott sofőröket, akik a résztvevőt a Awarddal kapcsolatos tevékenységek céljából szállítják. Megértettem, hogy a programközpont előzetesen értesít minden ilyen jellegű utazásról.",
  "parentalConsent.i_as_the_parent": "3. Megértettem, hogy bizonyos tevékenységek magasfokú kockázattal járnak, és bizonyos, magasfokú kockázattal járó tevékenységek esetében a programoperátor biztosítása nem érvényes. Megértettem, hogy minden, a résztvevő programban való részvelével járó kockázat kizárólag a résztvevőt terheli.",
  "parentalConsent.i_authorise_employees": "4. Felhatalmazom a programközpont alkalmazottait, hivatalnokait vagy ügynökeit és minden más személyt, aki segíti a program lebonyolítását, hogy abban az esetben, ha a résztvevő sérülést, megbetegedést vagy bármilyen veszteséget szenved, miközben a programmal kapcsolatos utazásban vagy tevékenységben vesz részt, igénybe vegyenek minden szükséges orvosi segítséget vagy kezelést, ideértve, de nem kizárólag orvos, asszisztens vagy kórházi beutalás igénybevételét.",
  "activity.cannot_edit_activity_if_award_in_state": "A tevékenység nem szerkeszthető, ha a program helyszíne {state} állam",
  "route.customization": "Személyreszabás",
  "label.is_completed": "Teljesítve",
  "label.state": "Állam",
  "label.trained_award_leader": "Képzett Award Líder",
  "label.switch_organization": "Szervezet váltása",
  "label.password": "Jelszó",
  "label.participants_total": "Résztvevők, összes",
  "label.position_in_organization": "Pozíció a szervezetben",
  "label.user_does_not_have_permissions": "<strong>{user}</strong> felhasználó nem jogosult ennek a tartalomnak a megtekintésére.",
  "label.current_award": "Jelenlegi Awardfokozat",
  "label.profile": "Profil",
  "label.logout": "Kijelentkezés",
  "label.award_unit": "Programközpont",
  "label.you_are_already_logged_as": "Már bejelentkeztél, mint",
  "button.logout": "Kijelentkezés",
  "button.search": "Keresés",
  "button.remove_photo": "Fotó eltávolítása",
  "button.go_to_dashboard": "Váltás az irányítópultra",
  "button.login_with_another_account": "Bejelentkezés más felhasználói adatokkal",
  "button.login": "Bejelentkezés",
  "button.add_training": "Képzés hozzáadása",
  "placeholder.start_typing": "Ide írhatsz…",
  "placeholder.select": "Kiválasztás",
  "notifications.aj_preparation_training_has_been_returned": "Kalandra való felkészülés és gyakorlás felülvizsgálva",
  "notifications.aj_preparation_training_has_been_approved": "Kalandra való felkészülés és gyakorlás jóváhagyva",
  "table.note": "Üzenet",
  "table.note_from_al": "Megjegyzés Award Lídertől",
  "table.date": "Dátum",
  "table.is_completed": "Teljesítve",
  "table.assessor_report": "Kiértékelő jelentés",
  "participant.deactivate_account": "Fiók megszüntetése",
  "participant.reactivate_account": "Fiók visszaállítása",
  "moduleTitle.login": "Bejelentkezés",
  "moduleTitle.select_organization": "Szervezet kiválasztása",
  "moduleTitle.aj_preparation_and_training": "Kalandra való felkészülés és gyakorlás",
  "moduleTitle.user_added_preparation_and_training": "Felhasználó hozzáadta a felkészülést és gyakorlást",
  "moduleTitle.training": "gyakorlás",
  "moduleTitle.award_unit": "Programközpont",
  "states.inactive": "Archívum",
  "errors.invalid_phone_format": "Érvénytelen telefonszám",
  "errors.invalid_email_address": "Érvénytelen e-mail cím",
  "errors.required_field": "Kötelező mező",
  "errors.must_be_at_least": "Legalább {min} karakter kell legyen",
  "errors.must_be_no_more_than": "Nem lehet több, mint {max} karakter",
  "errors.must_be_an_integer": "Egész szám kell legyen",
  "errors.must_be_one_of": "A következők közül az egyik: {enums}",
  "errors.do_not_match": "Ne párosítsa",
  "parentalConsent.images_consent": "Szülőként/gyámként beleegyezem abba, hogy a program során készült fényképeket, valamint az annak végén írt személyes gondolatokat a International Award Foundation felhasználja a program népszerűsítésére.",
  "global.day": "nap",
  "global.days": "nap",
  "global.night": "éjszaka",
  "global.nights": "éjszaka",
  "pageTitle.award_documents": "Award dokumentumok",
  "route.awards": "Awardok",
  "label.pending_changes": "Változások függőben...",
  "label.new_goal": "Új Célkitűzés",
  "label.leaders": "Líderek",
  "label.name_of_the_unit": "Egység neve",
  "label.confirmed": "Igazolva",
  "label.waiting": "Várakozás",
  "button.change_state": "Státusz változtatása",
  "button.change_goal": "Célkitűzés megváltoztatása",
  "button.setup": "Beállítás",
  "button.create_new": "Új létrehozása",
  "notifications.file_has_been_uploaded": "Fájl feltöltve",
  "notifications.file_has_been_updated": "Fájl frissítve",
  "notifications.file_has_been_removed": "Fájl eltávolítva",
  "notifications.log_has_been_removed": "Napló eltávolítva",
  "notifications.role_has_been_updated": "Szerep frissítve",
  "notifications.preparation_training_has_been_added": "Felkészülés és gyakorlás hozzáadva",
  "notifications.preparation_training_has_been_removed": "Felkészülés és gyakorlás visszavonva",
  "notifications.activity_has_been_setup": "Tevékenység beállítása megtörtént",
  "notifications.rp_has_been_setup": "Tartózkodási projekt beállítva",
  "notifications.rp_state_has_been_changed": "Tartózkodási projekt státusza megváltozott",
  "tabs.documents": "Dokumentumok",
  "table.file": "Fájl",
  "table.title": "Cím",
  "table.uploaded_by": "Feltöltő",
  "table.adventurous_journey_detail": "Kaland adatai",
  "table.section": "Szakasz",
  "award.award_detail": "Award adatai",
  "award.bronze_level": "Bronz fokozat",
  "award.silver_level": "Ezüst fokozat",
  "award.gold_level": "Arany fokozat",
  "aj.minimum_date_requirements": "Minimális időtartam követelmény a minősítő Kaland és {name} esetében",
  "moduleTitle.confirm": "Igazolás",
  "moduleTitle.files": "Fájlok",
  "moduleTitle.remove_file": "Fájl eltávolítása?",
  "moduleTitle.would_you_like_to_remove_this_log": "Szeretnéd törölni ezt a naplót?",
  "states.finished": "Befejezve",
  "states.journey_approval": "Utazás jóváhagyása",
  "states.section_signoff": "Szakasz jóváhagyása",
  "states.office_signoff": "Programközpont jóváhagyása",
  "states.awaiting_approval": "Jóváhagyásra várva",
  "errors.some_fields_requires_your_attention": "Egyes mezőknek több figyelmet kell szentelj",
  "errors.must_be_more_than": "Többnek kell lennie, mint {limit}",
  "errors.minimal_duration_is": "Minimális időtartam 30 perc",
  "pageTitle.award_leaders": "Award Líderek",
  "pageTitle.participants": "Résztvevők",
  "pageTitle.payments": "Kifizetések",
  "pageTitle.detail": "Részletek",
  "pageTitle.awards": "Awardok",
  "pageTitle.suboperating_authorities": "Operátor partneri alegységek",
  "pageTitle.operating_authorities": "Operátor partnerek",
  "pageTitle.independent_award_centers": "Független programközpontok",
  "sidebar.operating_authorities": "Operátor partnerek",
  "sidebar.suboperating_authorities": "Operátor partneri alegységek",
  "sidebar.independent_award_centers": "Független programközpontok",
  "sidebar.regions": "Régiók",
  "route.history": "Előzmények",
  "label.operating_authority": "Operátor partner",
  "label.suboperating_authority": "Operátor partneri alegység",
  "label.repeat_email": "E-mail megismétlése",
  "label.award_unit_type": "Programközpont típus",
  "label.created_at": "Létrehozva",
  "label.migrated_contact_email": "E-mail elérhetőség áttelepítve",
  "button.set": "Beállítás",
  "notifications.adventurous_journey_state_has_been_changed": "A kaland státusza megváltozott",
  "notifications.login_details_have_been_changed": "A bejelentkezési adatok megváltoztak",
  "notifications.authorization_contact_has_been_set": "Az engedélyező elérhetősége beállítva",
  "notifications.coordinator_has_been_set": "Koordinátor beállítva",
  "tabs.history": "Előzmények",
  "table.description": "Leírás",
  "table.approved": "Jóváhagyva",
  "moduleTitle.coordinator": "Koordinátor",
  "moduleTitle.assessor_detail": "Kiértékelő adatai",
  "errors.passwords_dont_match": "A jelszók nem egyeznek",
  "errors.emails_dont_match": "Az e-mail cím nem talál",
  "pageTitle.regions": "Régiók",
  "note.change_the_email_will_change": "Megjegyzés: az e-mail megváltoztatása megváltoztatja az áttelepített e-mail elérhetőséget is",
  "sidebar.my_office": "Az irodám",
  "table.weeks_completed_required": "Teljesített / Kötelező hetek",
  "participant.level_registration_date": "{value} Regisztráció dátuma",
  "moduleTitle.note_from_al": "Megjegyzés a Award Lídertől",
  "parentalConsent.i_consent_to_pay_all": "5. Beleegyezem minden olyan orvosi és kórházi ellátási költség megtérítésébe, amely a résztvevő által a programban való részvételével összefüggő tevékenység helyszínére vagy helyszínéről való utazás során szerzett baleset, sérülés, betegség vagy veszteség során lép fel. ",
  "parentalConsent.i_consent_to_and_understand_that": "6. Megértettem és egyetértek azzal, hogy fényképek készülnek a résztvevőkről a program tevékenységeiben való részvételük során, ezeket a fényképeket pedig a program népszerűsítésére lehet felhasználni, feltéve, hogy a résztvevő és a szülő/gyám is aláírta a megfelelő beleegyező űrlapot.",
  "parentalConsent.i_have_read_and_understand": "7. Elolvastam és megértettem a program különböző szintjeit és követelményeit leíró részt a program áttekintésében (a jelen űrlap 5. oldalán).",
  "parentalConsent.i_understand_every_participant_must": "8. Megértettem, hogy minden résztvevő egy programközponton keresztül csatlakozhat a programba, amelynek jogában áll résztvevők és a program részeként javasolt tevékenységek elfogadására vagy elutasítására.",
  "parentalConsent.i_understand_that_the_participant_cannot": "9. Megértettem, hogy a résztvevő nem kezdheti el a program adott szakaszát mindaddig, amíg meg nem győződtem arról, hogy a résztvevő által megnevezett önkéntes, aki nem a programközpont alkalmazottja, kellőképpen tapasztalt és/vagy képzett ahhoz, hogy a program adott szakaszát irányítsa/felügyelje/kiértékelje, és a megfelelő önkéntesek ki nem töltötték és el nem küldték a szükséges dokumentációt a programközpontnak.",
  "parentalConsent.i_understand_that_upon_acceptance_into": "10. Megértettem, hogy a résztvevő programba való felvételével a programközpont által, a résztvevő kap egy Record Book fiókot vagy hozzáférést az Online Record Book (ORB) platformra. A résztvevő elolvassa a Record Bookban vagy ORB platformon megadott követelményeket, mielőtt elkezdené a programmal kapcsolatos tevékenységeket. Megértettem, hogy a programközpontnak jogában áll megállapítani, hogy a résztvevő teljesítette-e a követelményeket, és megkaphatja-e a bronz, ezüst vagy arany Awardot. Megértettem, hogy a programoperátor személyi baleset esetében korlátozott felelősséget vagy általános felelősségbiztosítást vállal a programban való felvétellel, de a személyi balesetbiztosítás megszerzésének felelőssége a résztvevőre és a szülőre/gyámra hárul.",
  "parentalConsent.i_understand_that_a_and_b": "11. Megértettem, hogy: <br /> a. résztvevő nem vezethet motoros járművet vagy nem szállíthat tevékenységben résztvevő más személyeket, kivéve, ha a résztvevő érvényes járművezetői engedéllyel és a megfelelő biztosítással rendelkezik, amely fedezi a járművezetés közben fellépő esetleges személyi sérülést; és hogy <br /> b. a résztvevőt nem szállíthatja a programban nem résztvevő vagy azt nem segítő személy a programmal kapcsolatos tevékenység céljából, kivéve, ha az adott személy érvényes járművezetői engedéllyel és a megfelelő biztosítással rendelkezik, amely fedezi a járművezetés során fellépő esetleges személyi sérülést.",
  "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Tudomásul veszem, hogy a résztvevőknek meg kell felelniük a Record Bookban vagy az ORB-ben szereplő Award követelményeknek, a megfelelő programoperátor (időről időre módosított) szabályzatának és viselkedési normáinak, valamint a programközpont követelményeinek a vészhelyzeti tervekkel, a tevékenységek értékelésével és az Awarddal kapcsolatos kaland lebonyolításával kapcsolatban, és tudomásul veszem, hogy az Awardközpont visszavonhatja a résztvevőnek az programban való részvételére vonatkozó engedélyét, ha nem tartja be a követelményeket.",
  "parentalConsent.i_consent_to_the_provision_of_any": "12. Megértettem, hogy a résztvevőknek meg kell felelniük a program Record Bookban vagy az ORB felületen összefoglalt követelményeinek, a programoperátorra vonatkozó politikáinak és viselkedési szabályainak (a szükséges módosításokkal), és a programközpont sürgősségi helyzetekre, tevékenységek kiértékelésére és a program keretében megtett kalandok szervezésére vonatkozó követelményeinek, valamint megértettem, hogy a programközpont megvonhatja a résztvevőtől a programban való részvétel jogát, ha mindezen a követelményeknek nem felel meg.",
  "parentalConsent.the_award_operators_are_committed_to_respecting": "14. A programoperátorok vállalják az adatai védelmét. Jelen űrlapon kitöltött személyes információk a programban való részvételt szolgálják. Az ezeket az információkat nem megadó résztvevők nem kapcsolódhatnak be a programba (megj. ez nem vonatkozik a résztvevői adatok meg nem adására). A személyes adatait arra is felhasználhatjuk, hogy információkat küldjünk a programmal kapcsolatos további tevékenységekről vagy eseményekről, amelyekről úgy gondoljuk, hogy érdekelhetik. Ezeket az információkat megadhatjuk olyan helyi vagy nemzetközi szervezeteknek és szolgáltatóknak, akik segítenek nekünk a program szervezésében és lebonyolításában. Ha szeretné felvenni velünk a kapcsolatot vagy hozzáférni a személyes adataihoz, írjon a programoperátornak. A programoperátortól azt is kérheti, hogy küldje el az adatvédelmi szabályzatát.",
  "award.bronze_level_short": "Bronz",
  "award.silver_level_short": "Ezüst",
  "award.gold_level_short": "Arany",
  "assessor_report.returned_to_participant": "Visszaküldve a résztvevőnek",
  "pageTitle.user_guide": "Felhasználói útmutató",
  "sidebar.my_award_unit": "A programközpontom",
  "notifications.preparation_training_has_been_updated": "Felkészülés és gyakorlás frissítve",
  "sidebar.user_guide": "Felhasználói útmutató",
  "label.payment": "Fizetés",
  "label.payment_date": "Fizetés dátuma",
  "label.transaction_id": "Tranzakció azonosítója",
  "label.name_organization": "Név",
  "route.user_guide": "Felhasználói útmutató",
  "label.user_guide": "Felhasználói útmutató",
  "route.upload": "Feltöltés",
  "global.no_results": "Nincs találat",
  "route.user_guide_web_nao": "Web felhasználói útmutató - országos programoperátor",
  "route.user_guide_web_leader": "Web felhasználói útmutató - Award Líder",
  "route.user_guide_web_participant": "Web felhasználói útmutató - résztvevő",
  "label.coordinator": "Koordinátor",
  "label.user_guide_web_nao": "Web felhasználói útmutató - országos programoperátor",
  "label.user_guide_web_leader": "Web felhasználói útmutató - Award Líder",
  "label.user_guide_web_participant": "Web felhasználói útmutató - résztvevő",
  "label.page_not_found": "404 - Az oldal nem elérhető",
  "label.no_results": "Nincs találat",
  "label.organization_type": "Szervezet típusa",
  "table.parent": "Szülő",
  "moduleTitle.award_leader": "Award Líder",
  "moduleTitle.page_not_found": "404 -  Az oldal nem elérhető",
  "label.already_running": "Folyamatban",
  "label.online_payments": "Online kifizetések",
  "button.change_password": "Jelszó megváltoztatása",
  "errors.at_least_num_characters": "Legalább {length} karakter",
  "errors.include_at_least_one_number": "Tartalmaznia kell legalább egy számjegyet",
  "errors.include_both_lower_and_upper_case": "Tartalmaznia kell kis- és nagybetűt is",
  "label.current_password": "Jelenlegi jelszó",
  "label.new_password": "Új jelszó",
  "label.repeat_new_password": "Új jelszó ismét",
  "notifications.password_has_been_changed": "Jelszó megváltoztatása megtörtént",
  "table.suboperating_authorities": "Operátor partneri alegység",
  "table.operating_authorities": "Operátor partner",
  "meta.dofe_name": "The Duke of Edinburgh's International Award",
  "label.user_app_guide_participant": "Útmutató applikációhoz - résztvevő",
  "label.user_app_guide_leader": "Útmutató applikációhoz - Award Líder",
  "button.run": "Futtatás",
  "notifications.connecting_to_server": "Kapcsolódás a szerverhez…",
  "notifications.file_url_is_not_specified_in_configuration": "URL fájl nincs megadva a konfigurációban",
  "table.run": "Futtatás",
  "pageTitle.customizations": "Személyre szabott beállítások",
  "label.me": "(én)",
  "table.organization": "Szervezet",
  "label.international_region": "Nemzetközi régió",
  "label.national_award_authority": "Országos Programigazgató Hatóság",
  "button.back_to_home": "Vissza a kezdőlapra",
  "button.adventurous_journey_settings": "Kaland beállítások",
  "button.adventurous_journey_template_settings": "Kaland sablon beállítások",
  "button.select": "Kiválasztás",
  "notifications.template_has_been_removed": "Sablon eltávolítva",
  "tabs.customizations": "Személyre szabott beállítások",
  "moduleTitle.adventurous_journey_settings": "Kaland beállítások",
  "moduleTitle.adventurous_journey_template_settings": "Kaland sablon beállítások",
  "moduleTitle.remove": "Eltávolít?",
  "moduleTitle.are_you_sure": "Biztos?",
  "moduleTitle.select_role_organization": "Szerep és szervezet kiválasztása",
  "label.independent_country": "Független ország",
  "notifications.adventurous_journey_has_been_removed": "Kaland eltávolítva",
  "route.my_region_office": "Regionális irodám",
  "button.update": "Frissítés",
  "button.download": "Letöltés",
  "notifications.configuration_value_has_been_updated": "Konfigurációs érték frissítve",
  "tabs.sign_offs": "Engedélyek",
  "tabs.sign_offs_locally": "Helyi engedély",
  "aj.cannot_modify_award_level_if_participants_are_assigned": "A Award fokozata nem módosítható, ha résztvevők vannak bejelölve a kalandra",
  "moduleTitle.updateConfigurationKey": "Konfigurációs kulcs frissítése",
  "label.independent_award_centre": "Független programközpont",
  "aj.minimum_date_recommendation": "Minimális időtartam javaslat gyakorló utazásra és {name} esetében:",
  "pageTitle.related_contacts": "Kapcsolódó elérhetőségek",
  "pageTitle.profile_questions": "Profilkérdések",
  "pageTitle.customisations": "személyre szabott beállítások",
  "pageTitle.logs": "Naplók",
  "label.other": "Egyéb",
  "label.award_state": "Award státusza",
  "notifications.confirmation_email_has_been_sent": "Igazoló e-mail elküldve",
  "table.review": "Áttekintés",
  "participant.send_confirmation_email_again": "Újra elküldöd az igazoló e-mailt?",
  "participant.send_confirmation_email_again_question": "Újra elküldöd az igazoló e-mailt?",
  "moduleTitle.revise_message": "Üzenet áttekintése",
  "meta.page_not_found": "Oldal nem található",
  "button.save_changes": "Változtatások mentése",
  "button.upload": "Feltöltés",
  "tabs.waiting_payments": "Várakozás kifizetésekre",
  "tabs.expired_payments": "Lejárt kifizetések",
  "tabs.payments": "Kifizetések",
  "table.paid_by": "Fizető",
  "table.payment_link": "Link fizetéshez",
  "moduleTitle.global_payment_method": "Globális fizetési mód",
  "pageTitle.payment": "Fizetés",
  "pageTitle.my_organization_payment": "Szervezetem - fizetés",
  "pageTitle.my_organization_detail": "Szervezetem - adat",
  "label.nao_price": "Országos programoperátori ár",
  "label.oa_price": "Programoperátori ár",
  "label.total": "Teljes",
  "label.direct_entrant": "Közvetlen belépő",
  "label.continuation_level": "Folytatólagos szint",
  "button.reset": "Visszaállítás",
  "notifications.payment_link_has_been_reset": "Fizetési link visszaállítva",
  "meta.payments_expired": "Fizetések - lejárt fizetések",
  "meta.payments_waiting": "Fizetések - várakozás",
  "label.override_payment_note": "Fizetési megjegyzés felülírása",
  "label.fax": "Fax",
  "label.for_award_unit": "Programközpontnak",
  "tabs.adventurous_journeys": "Kalandok",
  "button.new_aj_event": "Új kaland-esemény",
  "table.country": "Ország / Terület",
  "tasks.delete_registration": "Regisztráció törlése",
  "tasks.approve_registration": "Regisztráció jóváhagyása",
  "moduleTitle.participant_activities": "Résztvevő tevékenységei",
  "moduleTitle.participant_logs": "Résztvevő naplói",
  "label.organization_contact": "Szervezeti elérhetőség",
  "button.add_coordinator": "Koordinátor hozzáadása",
  "table.breakdown_of_hours": "Időtartam lebontása",
  "label.email_confirmed": "E-mail igazolva",
  "label.iac_type": "Független programközpont típus",
  "notifications.coordinator_has_been_removed": "Koordinátor visszavonva",
  "moduleTitle.coordinators": "Koordinátorok",
  "label.change_award": "Awardfokozat megváltoztatása",
  "notifications.award_level_has_been_changed": "Awardfokozat megváltoztatva",
  "button.send_confirmation_email_again_question": "Igazoló e-mail újraküldése",
  "notification.new_activity_added": "Új tevékenység hozzáadva",
  "moduleTitle.new_activity": "Új tevékenység",
  "label.activity_section": "Tevékenység szakasz",
  "states.deleted": "Törölve",
  "button.restore_activity": "Tevékenység visszaállítása",
  "label.activity_deleted_note": "A tevékenység törölve. A lenti gombra kattintva vissza tudja állítani.",
  "label.reached_activity_limit": "Tevékenységi határ elérve erre a szakaszra. A résztvevőnek minden szakaszban legtöbb 3 tevékenysége lehet.",
  "moduleTitle.assessor_report_reject": "Kiértékelői jelentés visszaküldve",
  "pageTitle.independent_countries": "Független országok",
  "sidebar.ics": "Független országok",
  "label.or_dont_agree": "Vagy nem ért egyet? ",
  "label.reject_application": "Jelentkezés visszaküldése jóváhagyás nélkül.",
  "label.please_comment_on_the_participants": "Írja le észrevételeit a résztvevő fejlődéséről/teljesítményéről/elköteleződéséről",
  "label.aj_template_note": "Megjegyzés sablonhoz",
  "table.date_submitted_to_office_signoff": "Résztvevő általi leadás / programközpont általi visszaküldés dátuma",
  "table.ic": "Független ország",
  "table.total": "Összes",
  "table.files": "Fájlok",
  "award.change_award_level": "Awardfokozat megváltoztatása",
  "award.inactive_award": "Award inaktiválása",
  "label.hours_first_letter": "óra",
  "label.content_update": "Várjon. Tartalom frissítése...",
  "button.award_settings": "Award beállítások",
  "button.try_again": "Figyelmeztetés bezárása és ismételt próbálkozás",
  "button.reload_page": "Oldal újratöltése",
  "table.hours": "Óra",
  "moduleTitle.lost_internet_connection": "Nincs internetkapcsolata",
  "label.please_leave_a_note": "Hagyjon megjegyzést",
  "table.observations": "Megfigyelések",
  "table.observation_files": "Megfigyelés fájlok",
  "table.observation_note": "Megfigyelés megjegyzés",
  "moduleTitle.update_configuration_value": "Konfigurációs érték frissítése",
  "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Inaktivitás miatt kiléptettek a rendszerből",
  "notifications.one_activity_has_to_remain": "A szakasz egyik tevékenysége aktív kell maradjon",
  "label.no_activities": "Nincsenek tevékenységek",
  "label.option": "Opció",
  "label.possible_values": "Lehetséges értékek:",
  "label.any_string": "Bármilyen karaktersor",
  "label.integer": "Egész szám",
  "label.text": "Szöveg",
  "label.options": "Opciók",
  "button.generate_report": "Jelentés generálása",
  "button.add_option": "Opció hozzáadása",
  "button.add_new_profile_question": "Új profilkérdés hozzáadása",
  "button.continue_to_payment_gateway": "Tovább a fizetési átjáróhoz",
  "notifications.new_question_has_been_added": "Új kérdés hozzáadva",
  "notifications.question_has_been_removed": "Kérdés visszavonva",
  "notifications.question_has_been_updated": "Kérdés frissítve",
  "notifications.participants_have_been_transferred": "Résztvevők áthelyezve",
  "table.participant_state": "Résztvevő státusza",
  "table.award_state": "Award státusza",
  "award.generate_award_report": "Jelentés generálása",
  "moduleTitle.which_section_do_you_want_to": "Melyik szakaszt szeretnéd visszaállítani a 'Folyamatban' státuszra?",
  "moduleTitle.edit_role": "Szerep szerkesztése",
  "button.resend": "Újraküldés",
  "button.resend_assessment_request": "Kiértékelés kérés újraküldése",
  "button.upload_photo": "Kép feltöltése",
  "notifications.assessment_request_has_been_sent": "Kiértékelés kérés elküldve",
  "moduleTitle.please_confirm": "Igazolja",
  "participant.change_participant_status": "Résztvevő státuszának megváltoztatása",
  "meta.profile_questions": "Profilkérdések",
  "label.transfer_participants": "Résztvevők áthelyezése",
  "meta.payments": "Kifizetések",
  "table.coordinator": "Koordinátor",
  "button.role_edit": "Szerkesztés",
  "text.all_participants_will_be_transfered": "Minden résztvevő új Award Líderhez irányítva",
  "pageTitle.assessment_send_successfully": "Kiértékelés sikeresen elküldve",
  "button.export_table": "Táblázat exportálása",
  "moduleTitle.export": "Exportálás",
  "table.award_signoff_attempts": "Próbálkozások Award aláírására",
  "tabs.independent_award_centers": "Független programközpontok",
  "route.my_region_office_customization": "Regionális irodám - személyre szabott beállítások",
  "button.restore": "Visszaállítás",
  "Activity log has been restored": "Értesítés. Tevékenységi napló visszaállítva",
  "pageTitle.adventurous_journeys": "Kalandok",
  "label.no_answers": "Nincs felelet",
  "notifications.authorization_code_has_expired": "Engedélyezési kód lejárt",
  "leader.delete_account": "Elérhetőség törlése",
  "roles.if_staff_superuser": "IAF szuper-felhasználói személyzet",
  "roles.if_staff_statistical_user": "IF statisztikai felhasználó",
  "roles.if_staff_viewer": "IAF személyzeti böngésző",
  "roles.aj_instructor": "Kaland oktató",
  "label.no_selected_participants": "Nincsenek kiválasztott résztvevők",
  "errors.auth_code_is_no_longer_valid": "Engedélyezési kód érvénytelen - használatban vagy elavult",
  "errors.please_contact_your_local_award_staff": "Vedd fel a kapcsolatot a helyi programszemélyzettel.",
  "errors.end_date_must_be_after_start_date": "Befejezési dátum nem lehet korábbi, mint a kezdési dátum",
  "label.assessment_with_role": "{role} kiértékelés",
  "moduleTitle.send_test_email": "Teszt e-mail küldése",
  "label.to": "Címzett",
  "label.cc": "Másolatot kap",
  "label.subject": "Tárgy",
  "label.message": "Üzenet",
  "notifications.award_leader_has_been_removed": "Award Líder visszavonva",
  "moduleTitle.you_have_been_logged_out_session_terminated": "Bejelentkezése lejárt, az időtartam lejárt",
  "contact.change_contact_status": "Elréhetőség státuszának módosítása",
  "contact.send_test_email": "Teszt e-mail küldése",
  "roles.naa_oa_staff": "Országos programigazgató hatóság személyzete",
  "label.switch_organisation_hint": "Bármikor megnyithatod a párbeszéd-ablakot a 'Váltás más szervezetre' kiválasztásával a fenti jobb oldali menüben",
  "pageTitle.search_results": "Találatok keresése",
  "route.assessors": "Kiértékelők",
  "label.link": "link",
  "label.if_your_download_doesnt_start": "Ha a letöltés nem indul automatikusan, kattintson ide",
  "notifications.award_unit_has_been_removed": "Programközpont/független programközpont eltávolítva",
  "table.expire_day": "Lejárati idő",
  "table.invited_by": "Meghívó",
  "table.as_assessor_for": "Kiértékelőként",
  "organisation.would_you_like_to_remove": "Szeretné eltávolítani ezt a szervezetet?",
  "moduleTitle.assessor_details": "Kiértékelő adatai",
  "moduleTitle.award_units": "Programközpontok",
  "label.wwc_expired": "WWC lejárt",
  "label.status": "Státusz",
  "label.wwc_number": "WWC szám",
  "label.expiration_date": "Lejárati dátum",
  "label.qualifications": "Minősítések",
  "button.add_history_record": "Előzmény bejegyzés hozzáadása",
  "table.child_protection_number": "Gyerekvédelmi szám",
  "moduleTitle.loggin_in": "Bejelentkezés",
  "moduleTitle.history": "Előzmények",
  "global.no_records": "Nincs bejegyzés",
  "button.invite_assessor": "Kiértékelő meghívása",
  "notifications.assessor_has_been_approved": "Kiértékelő jóváhagyva",
  "notifications.history_record_has_been_added": "Előzmény bejegyzés hozzáadva",
  "notifications.history_record_has_been_removed": "Előzmény bejegyzés visszavonva",
  "notifications.history_record_has_been_updated": "Előzmény bejegyzés frissítve",
  "notifications.assessor_has_been_rejected": "Kiértékelő felülvizsgálva",
  "notifications.person_state_has_been_changed": "Személy státusza megváltozott",
  "moduleTitle.invite_assessor": "Kiértékelő meghívása",
  "label.change_leader_status": "Vezető státuszának módosítása",
  "sidebar.assessors": "Kiértékelők",
  "button.invite": "Meghívás",
  "label.assessors_email": "Kiértékelő e-mailje",
  "moduleTitle.award_leader_edit": "Award Líder szerkesztése",
  "button.upload_files": "Fájlok feltöltése",
  "label.experience": "Tapasztalat",
  "notifications.assessor_has_been_updated": "Kiértékelő frissítve",
  "button.organisation_settings": "Szervezet beállítások",
  "organisation.change_organisation_state": "Szervezet státuszának módosítása",
  "organisation.remove_organisation": "Szervezet visszavonása",
  "tabs.assessors": "Kiértékelők",
  "tabs.additional_files": "Kiegészítő fájlok",
  "pageTitle.assessors": "Kiértékelők",
  "route.independent_award_centres": "Független programközpontok",
  "route.files": "Fájlok",
  "notifications.email_has_been_sent": "E-mail elküldve",
  "label.cannot_be_change_to_another": "Nem módosítható más Awardfokozatra",
  "label.secondary_email": "Másodlagos e-mail cím",
  "label.secondary_phone_number": "Másodlagos telefonszám",
  "label.secondary_phone_type": "Másodlagos telefon típus",
  "label.consent_already_given_login": "Beleegyezés megadva. Jelentkezzen be a gyerek nevében.",
  "button.proceed_to_login": "Tovább a bejelentkezéshez",
  "label.url_no_longer_valid": "Az URL nem érvényes.",
  "tasks.approve_assessor_registration": "Kiértékelő regisztráció jóváhagyása",
  "label.view_more": "Még több megtekintése",
  "button.upload_file": "Fájl feltöltése",
  "label.parental_consent": "Szülői beleegyezés",
  "label.author": "Szerző",
  "button.view_more": "Még több megtekintése",
  "label.section": "Szakasz",
  "moduleTitle.documents": "Dokumentumok",
  "label.content_restore": "Szakasz frissítése...",
  "label.frequently_asked_questions": "Gyakori kérdések (GYIK)",
  "label.award_start_date": "Program kezdési dátuma",
  "label.years_of_working_experience": "Munkatapasztalat években",
  "label.previously_worked_as_assessor": "Korábban dolgozott kiértékelőként",
  "button.resend_parental_consent": "Szülői beleegyezés újraküldése",
  "moduleTitle.resend_parental_consent_link": "Szülői beleegyezés link újraküldése?",
  "notifications.parental_consent_link_has_been_sent": "Szülői beleegyezés link elküldve",
  "notifications.participant_is_already_in_list": "A résztvevő már felkerült a listára",
  "errors.min_nights_required": "Legalább {nights} éjszaka a követelmény",
  "label.submitted_after_date": "Benyújtva a következő után:",
  "pageTitle.tasks_assessors_registration": "Kiértékelő regisztráció",
  "table.award_leader": "Award Líder",
  "states.supervisor_approval": "Kiértékelő jóváhagyás",
  "notifications.search_failed": "Keresés közben hiba történt. Próbálkozz újra.",
  "label.reason_for_changing_assessor": "Kiértékelő változtatásának oka",
  "errors.must_be_less_than": "Kevesebb kell legyen, mint {limit}",
  "moduleTitle.finance_system_data": "Pénzügyi rendszer adat",
  "label.number_of_records": "Bejegyzések száma",
  "notifications.configuration_value_has_been_reset": "Új konfigurációs érték beállítva",
  "label.photo_consent_given": "A résztvevő beleegyezik abba, hogy a profilképét népszerűsítésre használjuk.",
  "label.reason_of_deletion": "Törlés oka",
  "label.exchequer_number": "Államkincstári szám",
  "label.invoice_currency": "Számla pénzneme",
  "label.vat_treatment": "ÁFA kezelés",
  "label.vat_number": "ÁFA szám",
  "label.gnipp": "GNIPP / ALF Disc %  ",
  "label.child_protection_number": "Gyerekvédelmi szám",
  "moduleTitle.remove_customization_and_reset": "Visszavonja a személyreszabást és visszaállítja a konfigurációs értéket?",
  "table.independent_award_centre": "Független programközpont",
  "label.aj_is_not_approved_yet": "Kaland még nem engedélyezett",
  "notifications.search_cancelled": "Megszakítottad a keresést. Várnod kell, amíg a keresés befejeződik.",
  "table.date_time": "Helyi idő",
  "moduleTitle.adventurous_journey_detail": "Utazás részletei",
  "pageTitle.tasks_removed_registration": "Visszavont résztvevői regisztrációk",
  "button.move": "Áthelyezés",
  "notifications.organization_has_been_moved": "Szervezet áthelyezve",
  "notifications.participant_registration_has_been_removed": "Résztvevői regisztráció visszavonva",
  "tabs.removed_participant_registrations": "Visszavont résztvevői regisztrációk",
  "tasks.restore_participant_registration": "Visszaállítod a résztvevői regisztrációt?",
  "participant.invite_participant_to_next_level": "Meghívod a résztvevőt a következő szintre?",
  "moduleTitle.roles": "Szerepek",
  "notifications.notifications.invitation_has_been_sent": "Meghívó elküldve",
  "notifications.participant_registration_has_been_restored": "Résztvevő regisztráció visszaállítva",
  "sidebar.manual_data_import": "Manuális adatimportálás",
  "label.filename": "Fájlnév",
  "label.preparing_document_for_import": "Dokumentum előkészítése importálásra",
  "label.importing_file": "Fájl importálása",
  "label.size": "Méret",
  "label.last_modified": "Utolsó módosítás",
  "button.remove_file": "Fájl törlése",
  "button.import_data_from_selected_file": "Adat importálása a kiválasztott fájlból",
  "notifications.spreadsheet_has_been_imported_successfully": "Táblázat importálása sikeres volt",
  "notification.log_has_been_restored": "Tevékenységi napló visszaállítva",
  "contact.next_level_invitation": "Meghívó következő szintre",
  "organisation.would_you_like_to_move_award_unit": "Hova szeretnéd áthelyezni ezt a szervezetet?",
  "organisation.move_award_unit": "Programközpont áthelyezése",
  "label.here": "Ide",
  "errors.a_problem_has_occured_during_processing": "Feldolgozás alatt hiba történt, lásd további információk",
  "moduleTitle.after_assigning_a_role_to_yourself": "Miután kijelölted vagy módosítottad a szereped, újra be kell jelentkezned.",
  "label.award_office_signoff_date": "Programközpont jóváhagyásának dátuma",
  "label.award_leader_signoff_date": "Award Líder jóváhagyásának dátuma",
  "label.you_will_be_forced_to_login_again_after_change": "Változtatás után újra be kell jelentkezned",
  "notifications.participant_info_updated": "Résztvevői információ frissítve",
  "moduleTitle.server_is_unreachable": "A szerver nem elérhető",
  "error.server_cannot_be_reached_at_the_moment": "A szerver jelenleg nem elérhető. Próbálkozz újra.",
  "label.use_comma_for_multiple_entries": "Több adat bevitelekor használj vesszőt",
  "participant.participant_already_has_gold_award": "A résztvevőnek már van arany Awardja",
  "label.organisation_mode": "Szervezet mód",
  "organisation.change_award_unit_mode": "Szervezet mód módosítása",
  "organisation.change_award_mode": "Award módjának módosítása",
  "label.award_is_offline": "Az Award offline állapotban van",
  "moduleTitle.offline_award_units_signoff": "Offline Award Líder aláírása",
  "label.awardMode.offline": "Offline",
  "label.awardMode.hybrid": "Hibrid",
  "label.awardMode.online": "Online",
  "label.i_confirm_that_ive_witnessed": "Igazolom, hogy megtekintettem a résztvevők alábbi tevékenységekre kitöltött naplóját",
  "label.participant_is_semi_offline": "A résztvevő offline állapotban van",
  "label.award_mode": "Award üzemmódja",
  "heading.change_award_unit_mode": "Awardközpont üzemmódjának módosítása",
  "heading.change_awards_mode": "Award üzemmódjának módosítása",
  "notification.award_mode_has_been_updated": "Award üzemmódja frissítve",
  "activity.cannot_edit_activity_offline": "A résztvevő offline módban végzi a tevékenységet.<br><br>\nNem tudja szerkeszteni a tevékenységet, kalandt vagy Tartózkodási projektet, ha az Award fél-offline üzemmódban van.",
  "table.award_mode": "Award üzemmód",
  "notifications.this_role_has_read_only_persmission": "A szerephez csak olvasható jogosultság van rendelve",
  "table.operating_authority": "Operátor partner",
  "table.suboperating_authority": "Operátor partneri alegység",
  "roles.if_staff_stat_user": "IF statisztikai felhasználó",
  "label.no_config_key_available": "Nincs elérhető konfigurációs kulcs ehhez a szakaszhoz",
  "label.organisation_invoicing_name": "Licenc birtokos neve",
  "moduleTitle.lead_coordinator": "Fő koordinátor",
  "moduleTitle.other_coordinators": "Más koordinátorok",
  "moduleTitle.edit_coordinator": "Koordinátor szerkesztése",
  "moduleTitle.coordinator_settings": "Koordinátor beállítások",
  "notifications.lead_coordinator_has_been_set": "Új fő koordinátor beállítva",
  "label.participant_survey": "Résztvevő meghívókat kap az Alapítvány felméréseiben való részvételre.",
  "notifications.changes_have_been_saved": "Változtatások mentve",
  "award.bronze_to_gold_level": "Bronzról arany fokozatra",
  "label.created_after_date": "Létrehozás a következő dátum után:",
  "moduleTitle.emails": "E-mailek",
  "label.file_is_not_available": "Fájl nem elérhető",
  "label.if_download_doesnt": "Ha a letöltés nem indul el automatikusan, ellenőrizd a böngészőben a felugró beállításokat",
  "label.generating": "Generálás...",
  "label.participant_survey_parent": "{firstName} {lastName} szülőjeként/gyámjaként hozzájárulok, hogy  gyerekem/gondozottam lehetőséget kapjon a program keretében a résztvevők tapasztalatainak a megértése, a program eredményeinek és hatásainak a felmérése céljából végzett felmérésekben és más olyan kutatásokban való részvételre, amelyek összhangban vannak a program stratégiájával és célkitűzéseivel. Ha szeretne részletes információkat kapni a jelenlegi kutatásokról, kattintson ide: <a href={url}>here</a>",
  "label.parental_consent_email_info": "Ne felejtse el ellenőrizni a szülői e-mailt, és elküldeni a beleegyező nyilatkozatot a Award részletek oldalról.",
  "error.parent_email_must_be_filled": "Szülői e-mail kitöltése kötelező",
  "button.continue": "Folytatás",
  "notifications.translations_has_been_updated": "Fordítások frissítve",
  "notifications.translations_has_been_updated.button": "Fordítások sikeresen betöltve",
  "notifications.translations_has_been_updated.failure": "Fordítás frissítése sikertelen",
  "notifications.translationUpdateInterrupted": "Frissítés megszakítva",
  "label.par_reg_cust_note": "A tab lehetővé teszi a résztvevő regisztráció alatt megjelenő és a gyűjtött adatok mennyiségét meghatározó mezők személyre szabását. Ha módosítani szeretné, vegye fel a kapcsolatot a regionális irodával - csak az IAF rendszeradminisztrátora jogosult ezen változtatások elvégzésére.",
  "translationsManagement.modal.updateTitle": "Biztos benne?",
  "translationsManagement.modal.title": "Fordításokat akar frissíteni?",
  "translationsManagement.infoLabel": "Ez a jellemző lehetővé teszi fordítások frissítését a POEditor alkalmazáson keresztül",
  "translationsManagement.selectProject": "Projekt kiválasztása",
  "placeholder.selectLanguage": "Nyelv kiválasztása",
  "label.backend": "Backend",
  "label.backoffice": "Backoffice",
  "label.frontoffice": "Frontoffice",
  "button.updateSelectedLanguage": "Nyelv kiválasztása",
  "label.assessor_assesstment_award_start_date": "Award kiértékelés kezdési dátum",
  "label.person_status.activating": "label.person_status.activating",
  "moduleTitle.postalAddress": "moduleTitle.postalAddress",
  "table.utc_date_time": "UTC időzóna",
  "tabs.api_keys": "API-kulcsok",
  "pageTitle.apiKeys": "API-kulcsok",
  "button.add_key": "Kulcs hozzáadása",
  "table.key": "Kulcs",
  "table.lastUsed": "Utolsóként használt",
  "table.data_state": "Utolsó adatfrissítés",
  "label.current": "Jelenlegi",
  "text.hours_old": "{hours} óra",
  "sidebar.my_todolist": "Tennivalóim",
  "button.bulk_change": "Tömeges módosítás igazolása",
  "label.count_items_selected": "{count} tétel kiválasztva",
  "label.bulk_action_confirmation": "Tömeges művelet igazolása",
  "label.bulk_action_question": "Tömeges művelet elvégzése {count} tételen?",
  "label.bulk_action_results": "Tömeges művelet eredményei",
  "label.bulk_action_successful": "{count} tétel sikeresen módosítva.",
  "label.bulk_action_unsuccessful": "{count} tétel sikertelen:",
  "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email} mivel",
  "table.lead_coordinator": "Fő koordinátor",
  "table.last_log_added": "Utolsó napló hozzáadva",
  "moduleTitle.level_summary": "Szint összefoglaló",
  "label.last_activity_date": "Utolsó aktivitás dátuma",
  "Description of the combo box selection in bulk operation panel": {
    "label.bulk_operations": "Ömlesztett tevékenységek"
  },
  "label.award_leader": "Award Líder",
  "button.add_activity": "Tevékenység hozzáadása",
  "pageTitle.tasks_undelivered_emails": "Nem elküldött e-mailek",
  "table.action_requested": "Művelet szükséges",
  "table.advice": "Tanács",
  "table.participant_name": "Résztvevő neve",
  "table.participant_id": "Résztvevő azonosítója",
  "table.reason": "Ok",
  "label.undelivered_mail_reason": "E-mail el nem küldésének oka",
  "tasks.clear_email_revision": "Javított e-mail törlése",
  "button.notify_participant": "Visszatérés résztvevőhöz",
  "label.notify_email_explanation": "A résztvevő e-mailben értesítést kap arról, hogy kiértékelési kérését nem továbbították. Felkérik, hogy javítsa ki az e-mail címet és újra küldje el a kiértékelési kérést.",
  "label.is_major_activity_confirmation": "A résztvevőnek már van fő tevékenysége a program egy másik szintjén. Hozzá akar adni még egyet?",
  "title.confirmation": "Igazolás",
  "button.view_participant": "Résztvevőtől",
  "button.view_nao": "A programközpont küldte vissza (észrevétellel)",
  "label.orb_testing": "ORB tesztelés",
  "label.ctest_access": "Hozzáférés a tesztoldalhoz",
  "label.orb_account": "ORB fiók",
  "label.other_roles": "ORB profiloldal",
  "errors.email_or_phone_required": "Meg kell adnia egy e-mail címet vagy telefonszámot",
  "label.copy_to_clipboard": "{text} másolva a vágólapra.",
  "label.no_note_from_award_leader": "A programközponttól visszaküldve (észrevétel nélkül)",
  "label.no_note_from_participant": "Nincs megjegyzés a résztvevőtől",
  "label.resend_confirmation_email": "Igazoló e-mail újraküldése",
  "label.payment_type": "Fizetés típusa",
  "label.registration_approval_date": "Regisztráció jóváhagyásának dátuma",
  "info.aj_supervisor_is_mandatory": "A gyakorló kalandra a felügyelő kapja a kiértékelési kérést, a minősítő kalandra pedig a kiértékelő.",
  "warning.award_marked_as_paid": "Figyelem: legalább egy Awardfokozat vagy regisztráció kifizetettként van megjelölve. Visszaigazolás előtt nézze meg a kifizetési és visszatérítési útmutatót.",
  "participant.would_you_like_to_remove_registration": "Törlöd  a regisztrációt?",
  "warning.award_marked_as_paid_registration": "Figyelem: ez a Awardra való regisztráció kifizetettként van megjelölve. Visszaigazolás előtt nézze meg a kifizetési és visszatérítési útmutatót.",
  "label.aply_to_all_langs": "Minden nyelvre érvényes",
  "label.email_help_award_leader_full_name": "Award Líder teljes neve.",
  "label.email_help_award_leader_first_name": "Award Líder keresztneve.",
  "label.email_help_award_leader_email": "Award Líder e-mail címe.",
  "label.email_help_participant_full_name": "Résztvevő teljes neve.",
  "label.email_help_participant_first_name": "Résztvevő keresztneve.",
  "label.email_help_note": "Egyedi megjegyzés, ha be van állítva.",
  "label.email_help_custom_link": "Egyedi link, ha be van állítva.",
  "label.email_help_award_level": "Awardfokozat.",
  "label.email_help_activity_name": "Tevékenység neve.",
  "label.email_help_aj_category": "Kaland kategória.",
  "button.praise": "Észrevétel",
  "label.send_message": "Üzenet küldése",
  "button.show_list": "Lista megjelenítése",
  "button.apply": "Alkalmazás",
  "logs.offline": "Offline",
  "states.change_to_state_warning_missing_assessment": "FIGYELEM: a kiértékelés nincs hozzáadva. Mégis folytatja?",
  "states.change_to_state_warning_missing_hours_to_complete": "FIGYELEM: a kötelező minimális óraszám nincs rögzítve. Mégis folytatja?",
  "table.category": "Kategória",
  "label.category": "Kategória",
  "notifications.state_aj_preparation_training_has_been_changed": "Kalandra való felkészülés és gyakorlás állapota megváltozott.",
  "table.parental_consent": "Szülői beleegyezés",
  "label.change_parental_consent": "Szülői beleegyezés papírról elektronikus formátumba",
  "table.fields_included": "Mezők beiktatva",
  "table.recent_updates": "Megjegyzések és legújabb frissítések",
  "title.update_report": "Jelentés frissítése",
  "label.fields": "label.fields",
  "label.email_help_organization_name": "Programközpont neve.",
  "label.bulk_action_emailing": "Kiválasztott résztvevők e-mail címei",
  "label.prepare_new_email": "Új e-mail előkészítése",
  "contact.collect_emails": "E-mail címek begyűjtése e-mail küldéséhez",
  "label.blank_any_level": "ÜRES bármely szinten",
  "errors.file_is_too_large": "Maximális feltölthető terjedelem 20MB",
  "button.view_section": "Szakasz megtekintése",
  "errors.qualification_or_experience_required": "Képesítés vagy tapasztalat kötelező",
  "label.delete_participant_award_modal_question_detail": "Biztos benne, hogy törli {participantId} résztvevő {awardLevel} fokozatát?",
  "moduleTitle.award_participant_delete": "Awardfokozat törlése",
  "label.award_delete_participant_id": "Résztvevő azonosítója",
  "button.delete_award": "Awardfokozat törlése",
  "label.award_to_delete": "Awardfokozat törlendő",
  "label.delete_participant_award_info": "EZ A MŰVELET NEM VISSZAVONHATÓ. MÉG EGYSZER ELLENŐRIZZE A MEGADOTT ADATOK HELYESSÉGÉT.\nTörölni készül egy Awardfokozatot. Vegye figyelembe a következőket:\na) A résztvevőnek egynél több Awardfokozattal kell rendelkeznie \nb) A fő tevékenység beállítása megváltozik, ha része annak a Awardfokozatnak, amelyet törölni akar \nc) Ha a törlés után két Award marad, a fő tevékenység az alacsonyabb Awardfokozatra lesz beállítva, ha nincs a Award jóváhagyása/Teljesítve/Ceremónia állapotra állítva. ",
  "pageTitle.translationsManagement": "Fordítások kezelése",
  "label.ce_be": "Személyre szabott e-mailek (e-mail fordítások)",
  "label.ue_fe": "Felhasználói elköteleződés, Frontend (Résztvevő web statisztikai címkék)",
  "sidebar.translations_managment": "Fordítások kezelése",
  "pageTitle.manual_data_import": "Kézi adatimportálás",
  "label.select_sheet": "Lap választása a számítógépről",
  "notifications.award_was_deleted": "Award törlése megtörtént.",
  "label.participant_personal_reflection": "Résztvevő személyes gondolatai.",
  "label.your_report_has_been_rejected": "A kiértékelést jóváhagyás nélkül küldte vissza",
  "label.rejected_with_note": "Visszaküldve megjegyzéssel: \"{note}\"",
  "label.report_description": "A lenti táblázatokban a 'Fields included' (beiktatott mezők) és 'Recent updates' (legújabb frissítések) oszlopok jelenleg csak angol nyelven elérhetők. Próbáljuk megoldani más nyelvekre való lefordítását. Addig is elnézést kérünk - reméljük, hogy a jelentés funkció továbbra is hasznos.",
  "label.report_overview": "Áttekintés",
  "sidebar.guides_and_policies": "Útmutatók és jogszabályok",
  "moduleTitle.guides": "Útmutatók",
  "moduleTitle.policies": "Jogszabályok",
  "button.visit": "Látogatás",
  "button.show": "Megjelenítés",
  "label.privacy_notice": "Adatvédelmi tájékoztatás",
  "label.code_of_conduct": "Viselkedési szabályzat",
  "label.nao_regulations": "Országos programoperátor szabályzat",
  "label.terms_and_conditions": "Általános feltételek",
  "label.update_translations_results": "Fordítások frissítése találatok",
  "label.update_translations_successful": "{count} tétel sikeresen módosítva.",
  "label.update_translations_unsuccessful": "{count} tétel sikertelen:",
  "label.update_translations_error_item": "Fordítás frissítése sikertelen erre: {language}, kód: {localeCode}, projekt: {projectCode} mivel",
  "moduleTitle.update_translations": "Projekt fordítások frissítése",
  "label.update_translation_question": "A kiválasztott projektekre az összes fordítást frissíteni fogjuk.",
  "states.leader_signoff": "Szakasz jóváhagyása",
  "states.complete": "Teljes",
  "label.allow_log_after_25_yoa": "Naplók hozzáadásának engedélyezése 25 év fölött",
  "label.file_category": "label.file_category",
  "label.report": "Jelentés",
  "label.prevent_welcome_email_assessor": "Ne küldjön üdvözlő e-mailt a kiértékelőnek",
  "label.send_welcome_email": "Üdvözlő e-mail küldése",
  "tabs.registration_questions": "Regisztrációs kérdések",
  "label.org_contact_will_be_deleted": " Az utolsó funkciót törlöd, amellel ez a személy a szervezetben rendelkezett. Megtartod a személyes adatokat, mint vonatkozó elérhetőséget, vagy teljes egészében törlöd az elérhetőséget a szervezetből?",
  "label.email_help_person_full_name": "Személy teljes neve.",
  "moduleTitle.forbidden": "Tilos",
  "table.labels": "Címkék",
  "label.label": "Címke",
  "pageTitle.labels": "Címkék",
  "tabs.labels": "Címkék",
  "button.new_label": "Új címke",
  "moduleTitle.child_organization_labels": "Gyerekszervezet címkék",
  "moduleTitle.office_labels": "Iroda címkék",
  "table.organization_name": "Szervezet",
  "table.organization_type": "Szervezet típusa",
  "label.create_new_label": "Új címke létrehozása",
  "notifications.label_has_been_created": "Címke létrehozva.",
  "notifications.label_has_been_removed": "Címke frissítve.",
  "label.update_label": "Címke frissítése",
  "label.available_labels": "Hozzáférhető címkék",
  "notifications.label_has_been_assigned": "Címke hozzárendelése megtörtént.",
  "pageTitle.my_organization_labels": "Szervezetem - címkék",
  "label.please_comment_on_the_participants_effort": "Írja le, hogy a résztvevő milyen mértékben tett erőfeszítést a tevékenység céljának elérése érdekében",
  "label.bulk_action_assign_label": "Címke hozzárendelése",
  "label.assign_labels": "Címkék hozzárendelése",
  "moduleTitle.assign_labels_bulk": "Kiválasztott címkék hozzárendelése ${itemCount} résztvevőhöz.",
  "button.gop_assignment": "Globális operátor partner kinevezés",
  "tabs.sub_global_operating_partners": "Globális operátor partneri alegységek",
  "tabs.operating_partners": "Operátor partner",
  "tabs.sub_operating_partners": "Operátor partneri alegységek",
  "pageTitle.sub_global_operating_partners": "Globális operátor partneri alegységek",
  "sidebar.sgops": "Globális operátor partneri alegységek",
  "table.gop_name": "Globális operátor partner ",
  "moduleTitle.add_gop_role": "Globális operátor partner vagy globális operátor partneri alegység szerep hozzáadása",
  "label.gops": "Globális operátor partnerek",
  "sidebar.gops": "Globális operátor partnerek",
  "pageTitle.global_operating_partners": "Globális operátor partnerek",
  "organisation.manage_gop": "Globális operátor partner kezelése",
  "button.unassign": "Nem rendel hozzá",
  "label.safeguarding_policy": "Az International Award Alapítvány Biztonsági Politikája (ideértve a Viselkedési szabályzatot)",
  "label.code": "Operátor referencia",
  "label.action_required": "Intézkedés szükséges",
  "moduleTitle.assign_organization_labels_bulk": "Megjelölt cimkék hozzárendelése {itemCount} szervezetnek.",
  "moduleTitle.assign_contact_labels_bulk": "Megjelölt cimkék hozzárendelése {itemCount} lídernek.",
  "moduleTitle.unassign_labels_bulk": "Megjelölt cimkék hozzárendelésének feloldása {itemCount} résztvevőnek.",
  "moduleTitle.unassign_organization_labels_bulk": "Megjelölt cimkék hozzárendelésének feloldása {itemCount} szervezetnek.",
  "moduleTitle.unassign_contact_labels_bulk": "Megjelölt cimkék hozzárendelésének feloldása {itemCount} lídernek.",
  "moduleTitle.award_mode_change": "Résztvevő Award módjának megváltoztatása",
  "label.award_to_change": "Award szintet megváltoztatni",
  "label.change_award_mode_info": "label.change_award_mode_info",
  "label.change_award_mode_question_detail": "Bíztosan megváltoztatod {awardLevel} Award módod résztvevőre {participantId} - {participantName}.",
  "states.authorize_activity": "Tevékenység és kiértékelő jóváhagyása",
  "states.authorize_activity_description": "A tevékenység és a kiértékelő jóváhagyásával meghívót továbbítunk a kiértékelőnek a résztvevő elfogadására. Jóváhagyásod elküldésével igazolod, hogy tudomásul vetted: a kiértékelő megfelelő tapasztalattal rendelkezik az elfogadott tevékenység értékeléséhez.",
  "notifications.assessor_and_activity_has_been_approved": "Tevékenység és kiértékelő jóváhagyva, meghívó kiértékelőnek továbbítva",
  "button.authorize": "Jóváhagy",
  "label.last_log_ge": "Utolsó naplóbejegyzés ettól a dátumtól",
  "label.last_log_lt": "Utolsó naplóbejegyzés eddig a dátumig",
  "label.remove_log_set": "Bejegyzés beállítás teljes törlése",
  "label.allow_adding_logs_in_bulk": "Ömlesztett bejegyzés engedélyezése",
  "table.recipient_message_channel": "Üzenet csatorna",
  "label.group_messages_by_channel": "Csoport üzenetek csatorna",
  "table.group_id": "Csoport azonosító",
  "moduleTitle.assign_award_labels_bulk": "Award szint cimkék hozzárendelés",
  "moduleTitle.unassign_award_labels_bulk": "Award szint cimkék hozzárendelésének feloldása",
  "label.assign_award_labels": "Award szint cimkék hozzárendelés",
  "label.unassign_award_labels": "Award szint cimkék hozzárendelésének feloldása",
  "table.award_labels": "Award cimkék",
  "sidebar.message_center": "Üzenet központ",
  "label.award_label": "Award cimke",
  "label.organization_labels": "Szervezet cimke",
  "label.contact_label": "Award Líder cimke",
  "label.team_goal": "Csapat célkitűzése",
  "table.team_goal": "Csapat célkitűzése"

}